export default "__VITE_PUBLIC_ASSET__fce9e663__"